import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";

import React from "react";

const logo = require(`@/${process.env.REACT_APP_GLOBO_REPORT_LOGO}`);

const headerStyles = StyleSheet.create({
  headerContainer: {
    position: "relative",
    marginBottom: 20,
    paddingBottom: 15,
    borderBottom: "0.5pt solid #000",
    minHeight: 80,
    justifyContent: "center",
  },
  logoContainer: {
    position: "absolute",
    left: 30,
    top: "50%",
    marginTop: -30,
    width: 50,
    height: 50,
  },
  logo: {
    width: "100%",
    height: "100%",
  },
  contentContainer: {
    alignItems: "center",
    paddingHorizontal: 100,
  },
  companyName: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#002B5C",
    marginBottom: 4,
    letterSpacing: 1,
    textAlign: "center",
  },
  address: {
    fontSize: 9,
    marginBottom: 1,
    textAlign: "center",
    color: "#002B5C",
  },
  contactInfo: {
    fontSize: 8,
    color: "#002B5C",
    textAlign: "center",
  },
});

const PDFHeaderGlobo = React.memo(({ documentCode = "" }) => (
  <View style={headerStyles.headerContainer} fixed>
    {documentCode && <Text style={headerStyles.documentCode}>{documentCode}</Text>}

    <View style={headerStyles.logoContainer}>
      <Image src={logo} style={headerStyles.logo} />
    </View>

    <View style={headerStyles.contentContainer}>
      <Text style={headerStyles.companyName}>GLOBO ASIATICO ENTERPRISES, INC.</Text>
      <Text style={headerStyles.address}>JDK Bldg., 127 Maginhawa Street</Text>
      <Text style={headerStyles.address}>Teachers Village-East, Diliman, Quezon City 1101, Philippines</Text>
      <Text style={headerStyles.contactInfo}>Tels. : 982-7000 / 982-7032 to 36</Text>
      <Text style={headerStyles.contactInfo}>Telefax : 982 -8013; 433-0651</Text>
    </View>
  </View>
));

export default PDFHeaderGlobo;
